<template>
  <div class="CoalModel_adjustHistory_box">
    <div class="CoalModel_adjustHistory_box_title">
      <el-page-header @back="getReturn" content="操作历史"> </el-page-header>
    </div>
    <el-divider></el-divider>
    <el-form :inline="true" :model="form" class="demo-form-inline" size="small">
      <el-form-item label="">
        <el-form-item label="">
          <el-input v-model="form.dataPk" placeholder="手机号" clearable></el-input>
        </el-form-item>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="form.operationType" placeholder="操作类型" filterable clearable >
          <el-option
            v-for="item in operationTypeList"
            :key="item.code"
            :value="item.code"
            :label="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          v-model="form.operationTime"
          type="datetimerange"
          range-separator="至"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="修改开始"
          end-placeholder="修改结束">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <kt-button
          icon="fa fa-search"
          label="搜索"
          perms="-1"
          @click="getData(true)"
          type="primary"/>
      </el-form-item>
      <el-form-item>
        <kt-button
          icon="fa fa-share"
          label="重置"
          perms="-1"
          @click="getReset"
          type="primary"/>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="loading"
      :data="tableData"
      stripe
      size="mini"
      style="width: 100%">
      <el-table-column
        type="index"
        label="序号"
        fixed
        width="120">
      </el-table-column>
      <el-table-column
        prop="dataPk"
        label="手机号">
      </el-table-column>
      <el-table-column
        prop="operationRemark"
        label="操作类型">
      </el-table-column>
      <el-table-column
        prop="operationTime"
        label="操作时间">
      </el-table-column>
      <el-table-column
        prop="operationStaffName"
        label="操作人">
      </el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding:20px;">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float:right;">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import KtButton from '@/components/Core/KtButton'

export default {
  components: {
    KtButton
  },
  data() {
    return {
      size: 'small',
      loading: false,
      operationTypeList: [
        {
          code: '11',
          name: '移出黑名单'
        },
        {
          code: '12',
          name: '加入白名单'
        },
      ],
      operationModule: 12,
      pageNo: 1,
      pageSize: 10,
      form: {},
      coalTypeList: [],
      operatorList: [],
      // 表格数据
      tableData: [],
      totalSize: 0
    }
  },
  mounted() {
    this.getData(true)
  },
  methods: {
    async getData(val) {
      const _t = this
      if(val) {
        _t.pageNo = 1
      }
      _t.loading = true
      const params = {
        pageNo: _t.pageNo,
        pageSize: _t.pageSize,
        operationModule: _t.operationModule,
      }
      const form = { ..._t.form }
      let index = 0
      for (let key in form) {
        const val = form[key]
        if (val !== '') {
          params['searchFieldList[' + index + '].fieldName'] = key
          if (key === 'operationTime') {
            params['searchFieldList[' + index + '].rangeMinValue'] = val[0]
            params['searchFieldList[' + index + '].rangeMaxValue'] = val[1]
          } else {
            params['searchFieldList[' + index + '].singleValue'] = val
          }
          index++
        }
      }
      let res = _t.$api.coalModel.getLogList(params).then((res) => {
      let resData = res.data.dtoList || []
      _t.tableData = resData
      _t.totalSize = res.data.totalSize
      _t.loading = false
      })
    },

    // 重置
    getReset() {
      this.pageNo = 1;
      this.form = {}
      this.getData(true)
    },

    getReturn() {
      const _t = this
      _t.$emit('Adjust', false)
    },

    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo
      this.getData(false)
    }
  }
}
</script>
<style scoped lang="scss">
  .CoalModel_adjustHistory_box {
    box-sizing: border-box;
    .CoalModel_adjustHistory_box_title {
      padding: 10px;

      span:first-child {
        font-weight: 700;
        font-size: 32px;
        padding-right: 10px;
        cursor: pointer;
        vertical-align: middle;
      }

      span:last-child {
        font-weight: 700;
        font-size: 20px;
        vertical-align: middle;
      }
    }
  }
</style>
